import { getRowTimeMs } from './storyTimeUtils';
import { isKnownExerciseVesselApiId, normalizeExerciseVesselApiId } from './exerciseVesselRoleLookup';

/**
 * True when at least one exercise-scenario vessel has a position at or before story time.
 */
export function hasExerciseVesselFixAtPlayback(rawData, playbackTimeMs) {
  if (!rawData || rawData.length === 0) return false;
  for (const row of rawData) {
    const id = normalizeExerciseVesselApiId(row.unique_identifier);
    if (!id || !isKnownExerciseVesselApiId(id)) continue;
    const t = getRowTimeMs(row);
    if (Number.isNaN(t)) continue;
    if (playbackTimeMs != null && !Number.isNaN(playbackTimeMs) && t > playbackTimeMs) continue;
    const lat = row.lat ?? row.location_latitude;
    const lon = row.lon ?? row.location_longitude;
    if (lat != null && lon != null && !Number.isNaN(Number(lat)) && !Number.isNaN(Number(lon))) return true;
  }
  return false;
}
